export function getCustomFields(v) {
    let newObj = {
        Date: v.date,
        "Code": v.mdrtb_code,
        "Year": v.mdrtb_year,
        "Mono-Poly":v.patient?(parseInt(v.patient.mdrtb_monopoly) == 2 ? "Yes" : parseInt(v.patient.mdrtb_monopoly) == 3 ? "SG" : parseInt(v.patient.mdrtb_monopoly) == 4 ? "MGY" :'No'):'',
        Township: v.township.name,
        Township_Code:v.township.short_code,
        "Township Group ": parseInt(v.township.township_group_id) == 1 ? "MDR 1 " : parseInt(v.township.township_group_id) == 2 ? "MDR 2" : '',
        Volunteer: v.volunteer &&
            `${v.volunteer.name}(${v.volunteer.code})`,
        Type: v.supervision_type == 2 ? "By Phone" : v.supervision_type == 1 ? "By Person" : '',
        "DOT Type": v.dots_type == 2 ? "By DOT card" : v.dots_type == 1 ? "Though DOT application" : '',
        Remark: v.remark,
    };

    return newObj;
}